import Rellax from 'rellax'

const cmpParallax = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    const parallax = _.component.querySelector('.cmp-parallax__background')
    let rellax = null

    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    if (iOS) {
      parallax.style.backgroundAttachment = 'scroll'
    }
    // if (viewportWidth >= 768) {
    //   if (parallax) {
    //     function parallaxSize () {
    //       if (viewportWidth < 768) {
    //         parallax.setAttribute('data-rellax-percentage', '0.4')
    //       }
    //     }
    //     window.onresize = parallaxSize()
    //     const rellax = new Rellax(parallax, {
    //       breakpoints: [1024, 1440, 1920]
    //     })
    //   }
    // }
  }
}

export default cmpParallax
